import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'growth.inline-invite.invite-panel.title',
		description: 'Title of the inline invite',
		defaultMessage:
			'Invite {count, plural, one {<bold>{email}</bold>} =2 {<bold>{email}</bold> and <bold>1 other</bold>} other {<bold>{email}</bold> and <bold>{others} others</bold>}} to {product}',
	},
	skip: {
		id: 'growth.inline-invite.invite-panel.skip',
		description: 'Group email warning with dismiss action',
		defaultMessage:
			"<action>Skip</action> this if you're sharing to a group email or distribution list.",
	},
	invite: {
		id: 'growth.inline-invite.invite-panel.invite',
		description: 'Invite button text',
		defaultMessage: 'Invite',
	},
});

export default messages;
